import { createAction } from 'typesafe-actions';

export const setPage = createAction('SECTOR_PAGE_SET', action => (pageIndex: number) => action(pageIndex));

export const setPageSize = createAction('SECTOR_PAGE_SIZE_SET', action => (pageSize: number) => action(pageSize));
